import { ThemeSwitcher } from "./ThemeSwitcher";
import { LanguageSwitcher } from "./LanguageSwitcher";
import { CombinedSettingsMenu } from "./CombinedSettingsMenu";

export const FloatingSwitchers = () => {
  return (
    <>
      <LanguageSwitcher />
      <ThemeSwitcher />
    </>
  );
};
